import React, {useState, useEffect} from 'react';
import {Formik} from 'formik';

import {useToast, useFetch} from 'helpers/hooks';
import {Button} from 'components/Button';
import {Input} from 'components/Input';
import {Modal} from 'components/Modal';
import {NavSelect} from 'components/NavSelect';
import {request} from 'helpers/tools';

import styles from 'css_modules/Modal.module.css';

export const DirectRejectModal = ({close, doc, update, user}) => {
    const showToast = useToast();

    const [selectedUser, setSelectedUser] = useState(-1);

    const detail = useFetch(`/detail/${doc.uuid}/`);

    const sorted = detail.data
        ? detail.data.history
            .filter(item => item.event?.id === 'asg' || item.event?.id === 'crt')
            .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
        : [];

    const seen = new Set();

    const omitClientWhenMaintenancePresent = false;

    const hasMaintenanceRole = sorted.some(item => item.role === "Maintenance user");

    const asgUsers = [...sorted]
        .reverse()
        .filter(item => item.created_by_id !== user.pk)
        .filter(item => {
            if (
                omitClientWhenMaintenancePresent &&
                hasMaintenanceRole &&
                item.role === "Client user"
            ) {
                return false;
            }

            const key = `${item.created_by_id}-${item.role}-${item.level}`;

            if (seen.has(key)) {
                return false;
            }

            seen.add(key);
            return true;
        })
        .map(item => ({
            id: item.id,
            created_by_id: item.created_by_id,
            user: item.created_by,
            role: item.role,
            level: item.level,
            created_at: item.created_at,
        }));

    const navSelectData = asgUsers.map((item, index) => {
        const role = (item.role ?? '').toLowerCase();

        const shouldShowLevel =
            role.includes('schval') || role.includes('manag');

        return {
            id: item.id,
            title: shouldShowLevel
                ? `#${asgUsers.length - index } — ${item.user} - ${item.role} (Úr. ${item.level})`
                : `#${asgUsers.length - index } — ${item.user} - ${item.role}`,
            name: item.user,
            role: item.role,
            level: item.level,
            created_at: item.created_at,
        };
    });

    /*
    const selectedUserDetail = asgUsers.find(
        x => x.id === selectedUser
    );
    */

    const noReturnUsers =
        detail.data &&
        sorted.length > 0 &&
        asgUsers.length === 0;

    
    useEffect(() => {
        if (noReturnUsers) {
            showToast('Doklad není komu vrátit');
            close();
        }
    }, [noReturnUsers, showToast, close]);

    useEffect(() => {
        if (asgUsers.length > 0 && selectedUser === -1) {
            setSelectedUser(asgUsers[0].id);
        }
    }, [detail.data,asgUsers,selectedUser]);

    const selectChange = (e) => {
        setSelectedUser(parseInt(e.target.value));
    };

    const reject = async (rejectNote, user) => {
        close();

        const response = await request(
            `/my_documents/${doc.uuid}/direct_reject/`,
            'POST',
            {
                reject_note: rejectNote,
                returnTo: selectedUser,
            }
        );

        showToast(
            response.body?.returnedTo
                ? `Doklad vrácen: ${response.body.returnedTo}`
                : 'Doklad není komu vrátit.'
        );

        update();
    };

    if (!detail.data) return null;
    if (noReturnUsers) return null;
    
    return (
        <div className={styles.ontop}>
            <Modal name={doc.document_info.document_identifier? doc.document_info.document_identifier : doc.name} close={close}>
                <Formik initialValues={{reject_note: ''}}>
                    {({values}) => (
                        <>
                            <div >
                                <Input
                                    name="reject_note"
                                    component="textarea"
                                    rows="6"
                                    className={styles.body}
                                >
                                    Komentář k vrácení
                                </Input>
                            </div>

                            <div  style={{
                                "fontSize":"var(--s)",
                                "fontWeight" :"400",
                                "color":"var(--purple)",
                                "margin" :"1rem"
                                }}>
                                Komu vrátit: 

                                <NavSelect
                                name="returnedTo"
                                value={selectedUser}
                                onChange={selectChange}
                                data={navSelectData}
                                onlyvalid={true}
                            >
                                Vrátit uživateli
                            </NavSelect>
                            </div>
                            

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '1rem',
                                }}
                            >
                                <Button onClick={close}>
                                    Zavřít
                                </Button>

                                <Button
                                    primary
                                    onClick={() =>
                                        reject(values.reject_note, selectedUser)
                                    }
                                >
                                    Vrátit
                                </Button>
                            </div>
                        </>
                    )}
                </Formik>
            </Modal>
        </div>
    );
};